import { render, staticRenderFns } from "./AddReportCustomComponent.vue?vue&type=template&id=e871c5c4"
import script from "./AddReportCustomComponent.vue?vue&type=script&lang=js"
export * from "./AddReportCustomComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports